import { Link } from "react-router-dom";
import Notepad from "../components/notepad";
import SystemMessage from "../components/system_message";
import t from "../locales";
import youData from "../assets/images/you_data.png";
import youFind from "../assets/images/you_find.png";
import youGenerate from "../assets/images/you_generate.png";
import youGame from "../assets/images/you_game.png";
import youMail from "../assets/images/you_mail.png";
import youShare from "../assets/images/you_share.png";
import youSnap from "../assets/images/you_snap.png";
import youTalk from "../assets/images/you_talk.png";

function AppLink({ link, source, name, title }) {
  return (
    <Link className="screen-apps__link" to={link} title={title}>
      <img src={source} alt="" className="screen-apps__link-icon" />
      <p className="screen-apps__link-name">{name}</p>
    </Link>
  );
}

export default function Apps() {
  return (
    <>
      <SystemMessage text={t("apps_system_message")} saveStateName="apps" />
      <div className="screen-apps">
        <h1 className="screen-apps__title">{t("apps_title")}</h1>
        <div className="screen-apps__icons">
          <AppLink
            link="/youshare"
            source={youShare}
            name={t("app_names_you_share")}
            title={t("app_hint_you_share")}
          />
          <AppLink
            link="/yousnap"
            source={youSnap}
            name={t("app_names_you_snap")}
            title={t("app_hint_you_snap")}
          />
          <AppLink
            link="/yougame"
            source={youGame}
            name={t("app_names_you_game")}
            title={t("app_hint_you_game")}
          />
          <AppLink
            link="/youfind"
            source={youFind}
            name={t("app_names_you_find")}
            title={t("app_hint_you_find")}
          />
          <AppLink
            link="/youtalk"
            source={youTalk}
            name={t("app_names_you_talk")}
            title={t("app_hint_you_talk")}
          />
          <AppLink
            link="/youdata"
            source={youData}
            name={t("app_names_you_data")}
            title={t("app_hint_you_data")}
          />
          <AppLink
            link="/yougenerate"
            source={youGenerate}
            name={t("app_names_you_generate")}
            title={t("app_hint_you_generate")}
          />
          <AppLink
            link="/youmail"
            source={youMail}
            name={t("app_names_you_mail")}
            title={t("app_hint_you_mail")}
          />
        </div>
        <Notepad />
      </div>
    </>
  );
}
